<div class="full-height-column layout-spaced">
  <div class="boxed margin-auto">
    <div *ngIf="dataPackUpdate !== ''" class="content-pack-status">

      <div *ngIf="dataPackUpdate === 'checking-data'" class="status">
        <h1>{{ "pack-download.packStatusChecking" | i18next}}...</h1>
      </div>
      <div *ngIf="dataPackUpdate === 'downloading-data'" class="status">
        <h1>{{ "pack-download.packStatusDownloading" | i18next }}...</h1>
        <small>{{ "pack-download.packProgress" | i18next }} ({{ dataPackProgress }} %)</small>
      </div>

      <div *ngIf="dataPackUpdate === 'checking-media'" class="status">
        <h1>{{ "download.load-media" | i18next}}...</h1>
      </div>
      <div *ngIf="dataPackUpdate === 'downloading-media'" class="status">
        <h1>{{ "download.load-media" | i18next }}...</h1>
        <small>{{ "pack-download.packProgress" | i18next }} ({{ dataPackProgress }} %)</small>
      </div>
      <div class="progress-bar" *ngIf="dataPackUpdate === 'downloading-media' || dataPackUpdate === 'downloading-data'">
        <div class="progress" [style.width]="(dataPackProgress) + '%'">
        </div>
      </div>
      <p>{{ "pack-download.infoText" | i18next }}<br><small>{{ "download.infoText2" | i18next }}</small></p>

      <div class="btn primary small"
           *ngIf="dataPackUpdate === 'downloading-media' || dataPackUpdate === 'downloading-data'"
           (click)="abortMediaDownload()">{{ "download.cancel-download" | i18next }}</div>
    </div>
  </div>
</div>

